import { render } from "./miniapp.vue?vue&type=template&id=393ffb02&scoped=true"
const script = {}

import "./miniapp.vue?vue&type=style&index=0&id=393ffb02&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393ffb02"]])

export default __exports__